// extracted by mini-css-extract-plugin
export default {"wizard":"Wizard_wizard__YO1J5"};